export default "__VITE_ASSET__fPqRrkER__"